import React from "react";
import { Stack, Typography, Box, styled, useTheme } from "@mui/material";
import AgentLaunchpadDialog from "@hyro-components/Dialogs/agent-launchpad/AgentLaunchpadDialog";
import { DIALOG_VARIANTS } from "@hyro-components/Dialogs/DialogConsts";
import Chip from "@hyro-components/Chip";
import InfoIcon from "src/icons/InfoIcon";
import { PREPARE_PREVIEW_DIALOG_TEXT } from "./PreparePreviewDialogConsts";
import { ASSISTANT_ENIVRONMENT_UI_DATA } from "@consts";
import { usePreparePreviewDialog } from "./PreparePreviewDialog.hook";

const DialogContentContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexFlow: "column",
  gap: theme.spacing(3),
  paddingBottom: theme.spacing(1)
}));

const AgentNameContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.5),
  padding: theme.spacing(1.5),
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.system[0]
}));

const InfoBoxContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: theme.spacing(1),
  padding: theme.spacing(1.5),
  backgroundColor: theme.palette.info[100],
  border: `1px solid ${theme.palette.info[300]}`,
  borderRadius: theme.spacing(1)
}));

const RedeployPreviewDialog = ({ open, onClose }) => {
  const theme = useTheme();
  const testId = "redeploy-preview-dialog";
  const { isBuilding, handleConfirm, assistantName, environment } = usePreparePreviewDialog(onClose);

  return (
    <AgentLaunchpadDialog
      data-testid={testId}
      testId={testId}
      open={open}
      title={PREPARE_PREVIEW_DIALOG_TEXT.TITLE}
      submitButtonText={PREPARE_PREVIEW_DIALOG_TEXT.CONFIRM_BUTTON}
      cancelButtonText={PREPARE_PREVIEW_DIALOG_TEXT.CANCEL_BUTTON}
      variant={DIALOG_VARIANTS.transactional}
      handleSubmit={handleConfirm}
      handleCancel={onClose}
      handleClose={onClose}
      isLoading={isBuilding}
    >
      <DialogContentContainer>
        <Stack gap={2.25}>
          <AgentNameContainer>
            <Typography variant="subtitle2" color="text.800">
              {assistantName}
            </Typography>
            <Chip
              size="small"
              label={ASSISTANT_ENIVRONMENT_UI_DATA[environment]?.displayName}
              textColorPath={ASSISTANT_ENIVRONMENT_UI_DATA[environment]?.textColorPath}
              backgroundColorPath={ASSISTANT_ENIVRONMENT_UI_DATA[environment]?.backgroundColorPath}
            />
          </AgentNameContainer>

          <Typography variant="body1" color="text.700">
            {PREPARE_PREVIEW_DIALOG_TEXT.DESCRIPTION[environment]}
          </Typography>
        </Stack>

        <InfoBoxContainer>
          <Box sx={{ width: 16, height: 16 }}>
            <InfoIcon stroke={theme.palette.info[500]} />
          </Box>
          <Typography variant="body2" color="text.700">
            {PREPARE_PREVIEW_DIALOG_TEXT.INFO_MESSAGE}
          </Typography>
        </InfoBoxContainer>
      </DialogContentContainer>
    </AgentLaunchpadDialog>
  );
};

export default RedeployPreviewDialog;

